import React, { Component } from "react";
// import Chart from "react-apexcharts";
import ReactApexChart from "react-apexcharts";

export default class MonthlyAlarmTrendChart extends Component {
  constructor(props) {
    const colors = ["#3E6CA6"];

    super(props);
    this.state = {
      series: [
        {
          name: "",
          data: [50000, 20000, 35000, 10000, 20000, 8000, 5000, 22000],
        },
      ],
      options: {
        chart: {
          type: "bar",
        },
        xaxis: {
          categories: [
            "April",
            "May",
            "June",
            "July",
            "August",
            "September",
            "October",
            "November",
          ],
          title: {
            text: "Month", // Title for the X-axis
            style: {
              fontSize: "13px",
              fontWeight: "8px",
            },
          },
          labels: {
            style: {
              fontSize: "0.8rem", // Increase the font size here
              fontWeight: "bold", // Optional: make the font bold
              colors: ["#000000"], // Optional: change the label color if needed
            },
          },
        },
        yaxis: {
          title: {
            text: "Alarms", // Title for the X-axis
            style: {
              fontSize: "13px",
              fontWeight: "8px",
            },
          },
          labels: {
            formatter: function (val) {
              return parseInt(val);
            },
            style: {
              fontSize: "0.7rem", // Increase the font size here
              fontWeight: "bold", // Optional: make the font bold
              colors: ["#000000"], // Optional: change the label color if needed
            },
          },
        },
        dataLabels: {
          enabled: true,
          style: {
            colors: ["#656161"],
            fontSize: "12px",
            fontWeight: 700,
          },
          background: {
            enabled: true,
            foreColor: "#FFFFFF",
            borderRadius: 2,
            padding: 4,
            opacity: 0.9,
            borderWidth: 1,
            borderColor: "#FFFFFF",
          },
          offsetY: -20,
        },
        legend: {
          show: false,
        },
        colors: colors,
        plotOptions: {
          bar: {
            columnWidth: "90%",
            distributed: true,
            borderRadius: 5,
            dataLabels: {
              position: "top",
            },
          },
        },
      },
    };
  }
  render() {
    return (
      <div>
        <ReactApexChart
          options={this.state.options}
          series={this.state.series}
          type="bar"
          height={200}
        />
      </div>
    );
  }
}
